module.exports = __webpack_public_path__ + "img/背景2_素材.ff7ed7c8.svg";